<template>
  <div style="height: 12vw; max-height: 12vw; width: 100vw; z-index: 10;" v-if="appStep==states.MENU">
    <!-- /saison -->
    <div v-if="routeName === 'saison'" style="height: 100%; background-color: black; color: #ffffff88;
      display: grid;  font-size: 1.2em; font-weight: bold;" :style="'grid-template-columns: auto auto'">

      <div
          :style="currentNav === 'content'?'color: var(--goalBackgroundColor); border-bottom: 1vw var(--goalBackgroundColor) solid; padding-top:1vw; height:calc(100% - 2vw)':'height: 100%; opacity: 0.7'"
          class="flexwrap centercenter"
          @click="$emit('mobileChangeNav', 'content');">
        Série en cours
      </div>
      <div
        :style="currentNav === 'nav'?'color: var(--goalBackgroundColor); border-bottom: 1vw var(--goalBackgroundColor) solid; padding-top:1vw; height:calc(100% - 2vw)':'height: 100%; opacity: 0.7'"
        class="flexwrap centercenter"
        @click="$emit('mobileChangeNav', 'nav');">
      Progression</div>
    </div>

    <div v-else style="height: 100%; background-color: black; color: var(--goalBackgroundColor3);
      display: grid;  font-size: 1.2em; font-weight: bold;" :style="'grid-template-columns: auto'">
      <div
          style="border-bottom: 3px var(--watchColor) solid; padding-top:3px; height: 100%"
          class="flexwrap centercenter"
          @click="$router.push({name: 'saison'})">
        Retourner à ma série</div>
    </div>
  </div>
    <!--
    <div v-if="routeName==='blog'">
      <div style="height: 12vw; background-color: #101010; color: #666666;
      display: grid;  font-size: 1.2em; font-weight: bold;" :style="'grid-template-columns: auto auto'">
        <div
            :style="carousselNav.to==0 && currentRouterState!==-1?'color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'height: 100%'"
            class="flexwrap centercenter"
            @click="set_closableCardOpened(false); set_carousselNavTo(0)"
            v-if="appStep===states.MENU">
          Articles</div>
        <div
            :style="carousselNav.to==1?'color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'height: 100%'"
            class="flexwrap centercenter"
            @click="set_carousselNavTo(1); set_closableCardOpened(false)"
            v-if="appStep=== states.MENU && currentRouterState!==-1">
          article en cours
        </div>
      </div>
    </div>
    <div v-else>
      <div style="height: 12vw; width: 100vw; background-color: #101010; color: #666666;
      z-index: 10; display: grid;  font-size: 1.2em; font-weight: bold;" :style="authenticated?'grid-template-columns: 12vw 1fr 1fr':'grid-template-columns: 10vw 1fr'">
        <div
            :style="carousselNav.to==0 && currentRouterState!==-1?'color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'height: 100%'"
            class="flexwrap centercenter"
            @click="set_closableCardOpened(false); set_carousselNavTo(0)"
            v-if="appStep===states.MENU">
          <i class="fa-solid fa-grid"></i></div>
        <div
            :style="carousselNav.to==1?'color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'height: 100%'"
            class="flexwrap centercenter"
            @click="set_carousselNavTo(1); set_closableCardOpened(false)"
            v-if="appStep=== states.MENU && currentRouterState!==-1">
          Série
        </div>

        <div
            :style="carousselNav.to==2?'color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'height: 100%'"
            class="flexwrap centercenter"
            @click="set_carousselNavTo(2); set_closableCardOpened(false)"
            v-if="appStep=== states.MENU && currentRouterState!==-1 &&authenticated">
          Ma progression
        </div>

        <router-link :to="{name: 'profile'}"
                     :style="this.routeName === 'profile'?'text-decoration: none; color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'text-decoration: none; height: 100%; color: #666666'"
                     class="flexwrap centercenter"
                     v-if="appStep===states.MENU && currentRouterState===-1">
          Mon profil
        </router-link>
        <router-link :to="{name: 'premium'}"
                     :style="this.routeName === 'premium'?'text-decoration: none; color: var(--learnColor); border-bottom: 3px var(--watchColor) solid; padding-top:3px; height:calc(100% - 3px)':'text-decoration: none; height: 100%; color: #666666'"
                     class="flexwrap centercenter"
                     v-if="appStep===states.MENU && currentRouterState===-1">
          <span v-if="profile.datas.is_premium">
            Mon abonnement
          </span>
          <span v-else>
            Passer premium
          </span>
        </router-link>

      </div>
    </div>-->
  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
name: "navFooter",
  props: {
    authenticated: Boolean,
    currentRouterState: Number,
    currentNav: String
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'appStep',
      'states',
      'routeName',
      'carousselNav',
      'profile'
    ])
  },

  methods: {
    ...mapActions('global', [
        'set_closableCardOpened',
        'set_carousselNavTo',

    ])
  }
}
</script>

<style scoped>

</style>